import axios from 'axios'


const BASE_URL = 'http://localhost:3000/api'
// const BASE_URL = 'https://smallbiz-backend.herokuapp.com/api'

let apiToken = localStorage.getItem('small-biz-token')

if (apiToken) {
  axios.defaults.headers.common.Authorization = `Bearer ${apiToken}`
}

export async function login (email, password) {
  const res = await axios.post(`${BASE_URL}/auth/login`, { email, password })
  axios.defaults.headers.common.Authorization = `Bearer ${res.data.token}`
  apiToken = res.data.token
  localStorage.setItem('small-biz-token', apiToken)
  return res.data.userJson
};

export async function register (email, password) {
  const res = await axios.post(`${BASE_URL}/auth/register`, { email, password })
  axios.defaults.headers.common.Authorization = `Bearer ${res.data.token}`
  apiToken = res.data.token
  localStorage.setItem('small-biz-token', apiToken)
  return res.data.userJson
};

export function apiLogout () {
  localStorage.setItem('', apiToken)
  apiToken = null
}

export async function getUser () {
  const res = await axios.get(`${BASE_URL}/user`)
  return res.data.userJson
}

export function isLoggedIn () {
  return Boolean(apiToken)
}

export async function connectAccountWithPlaid (publicToken) {
  const res = await axios.post(`${BASE_URL}/plaid/connectAccountWithPlaid`, { publicToken })
  return res.data.accounts
}

export async function getPlaidAccounts (accout) {
  const res = await axios.post(`${BASE_URL}/plaid/plaidGetAccounts`, { accountId: accout._id })
  return res
}

export async function updateAccountName (accountId, displayName) {
  const res = await axios.post(`${BASE_URL}/plaid/updateAccountName`, { accountId, displayName })
  return res
}

export async function storeProcessingAccounts (accountId, processingAccounts) {
  const res = await axios.post(`${BASE_URL}/plaid/storeProcessingAccounts`, { accountId, processingAccounts })
  return res
}

export async function getPlaidTransactions () {
  const res = await axios.get(`${BASE_URL}/plaid/getPlaidTransactions`, {})
  return res.data.transactions
}

export async function sendContact (companyInfo) {
  const res = await axios.post(`${BASE_URL}/contact`, companyInfo)
  return res
}

export async function getPlaidPublicToken (accountId) {
  const res = await axios.get(`${BASE_URL}/plaid/getPlaidPublicToken?accountId=${accountId}`, {})
  return res.data.publicToken
}



// WEBPACK FOOTER //
// ./src/lib/api.js